import { useContext } from 'react';
import { Button, TextField, Grid, MenuItem } from '@material-ui/core';
import { UsersContext } from '../UsersContext';
import SearchIcon from '@material-ui/icons/Search';
import { FilterContainer } from 'components';
import { applicationContext } from 'helpers/services';

let Filters = () => {
    let { search, updateSearch, doSearch } = useContext(UsersContext);
    let { userGroups } = useContext(applicationContext)

    return (
        <FilterContainer onSubmit={() => doSearch(search)}>
            <Grid item xs>
                <TextField
                    fullWidth
                    label="Search user"
                    value={search.text}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            text: e.target.value
                        })
                    }}
                />
            </Grid>
            <Grid item xs>
                <TextField
                    fullWidth
                    label={"Group"}
                    select
                    value={search.group}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            group: e.target.value
                        })
                    }}
                >
                    <MenuItem value={""}>Any</MenuItem>
                    {userGroups.map(Group => <MenuItem key={Group.key} value={Group.key}>{Group.value}</MenuItem>)}
                </TextField>
            </Grid>
            <Grid item xs>
                <TextField
                    fullWidth
                    label={"Tickets permission"}
                    select
                    value={search.canWorkOnAllTickets}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            canWorkOnAllTickets: e.target.value || ""
                        })
                    }}
                >
                    <MenuItem value={""}>Any</MenuItem>
                    <MenuItem value={"true"}>Can work on all ticket</MenuItem>
                    <MenuItem value={"false"}>Can work on ticket assigned to my group</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <TextField
                    label={"Can delete tickets"}
                    fullWidth
                    select
                    value={search.canDeleteTicket}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            canDeleteTicket: e.target.value || ""
                        })
                    }}
                >
                    <MenuItem value={""}>Any</MenuItem>
                    <MenuItem value={"true"}>Yes</MenuItem>
                    <MenuItem value={"false"}>No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <TextField
                    label={"Can create tickets"}
                    fullWidth
                    select
                    value={search.canCreateTicket}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            canCreateTicket: e.target.value || ""
                        })
                    }}
                >
                    <MenuItem value={""}>Any</MenuItem>
                    <MenuItem value={"true"}>Yes</MenuItem>
                    <MenuItem value={"false"}>No</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <TextField
                    label={"Can reply to customer"}
                    fullWidth
                    select
                    value={search.canReplyToCustomers}
                    onChange={(e) => {
                        updateSearch({
                            ...search,
                            canReplyToCustomers: e.target.value || ""
                        })
                    }}
                >
                    <MenuItem value={""}>Any</MenuItem>
                    <MenuItem value={"true"}>Yes</MenuItem>
                    <MenuItem value={"false"}>No</MenuItem>
                </TextField>
            </Grid>



            <Grid item>
                <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                >
                    <SearchIcon />
                </Button>
            </Grid>
        </FilterContainer>
    );
}

export default Filters;